import { AIEmbeddingType, CompanyProfile } from 'models';

import { useArticles } from 'hooks/use-articles';

const useCaseStudies = (company: CompanyProfile) => {
    const { articles, ...swr } = useArticles(company.id, AIEmbeddingType.CASE_STUDY);

    const order = company.caseStudyOrder ?? [];

    const unordered = articles.filter((article) => !order.includes(article.id!));
    const ordered = order.map((id) => articles.find((article) => article.id === id)).filter((article) => !!article);

    return {
        ...swr,
        caseStudies: [...unordered, ...ordered],
    };
};

export { useCaseStudies };
